'use strict';
(function () {

    var _ = require('lodash'),
        model = require('json!../data/map.json'),
        gasp = require('gsap'),
        tpl = require('./templates/location.nunj'),
        AbstractView = require('./abstractview');


    var gs = window.GreenSockGlobals || {},
        _timelineIn = function () {

            var tl = new gs.TimelineMax({
                    align: "start",
                    stagger: 0
                }),
                wrapper = this.el.querySelector('.location-wrapper'),
                bg = document.getElementById('bg-container').querySelector('.bg:nth-child(2)'),
                ease = Quint.easeInOut;


            tl.eventCallback("onComplete", _.bind(function () {
                this.el.style.zIndex = 25;
            }, this), this);

            if (document.body.classList.contains('mobile')) {
                // mobile
                tl.set(this.el, {
                    y: '100%',
                    display: "block",
                    zIndex: 25
                });
                tl.to(this.el, 1.2, {
                    ease: ease,
                    y: '0%',
                    delay: 0.5
                });
            } else {
                // desktop
                tl.eventCallback("onStart", _.bind(function () {
                    this.el.style.zIndex = '';
                }, this), this);

                tl.set(bg, {
                    y: window.innerHeight,
                    x: 0,
                    backgroundColor: '#84D2DA',
                    display: 'block'
                });
                tl.set(this.el, {
                    display: 'block',
                    y: '0%'
                });
                tl.to(bg, 1.6, {
                    y: "50%",
                    delay: 0.25,
                    ease: Quint.easeInOut
                });

                _.each(wrapper.querySelector('.details').children, function (el, index) {
                    tl.from(el, 1.2, {
                        y: 60,
                        opacity: 0,
                        ease: Quint.easeInOut,
                        delay: 0.1
                    }, '-=1.2');
                }, this);

            }

            return tl;


        },
        _timelineOut = function () {
            var tl = new gs.TimelineMax({
                    align: "start",
                    stagger: 0
                }),
                bg = document.getElementById('bg-container').querySelector('.bg:nth-child(2)'),
                ease = Quint.easeInOut;


            tl.eventCallback("onComplete", _.bind(function () {
                this.el.style.zIndex = '';
            }, this), this);

            if (document.body.classList.contains('mobile')) {
                // mobile
                tl.to(this.el, 1, {
                    ease: ease,
                    y: '100%',
                    onComplete: _.bind(function () {
                        gs.TweenMax.set(this.el, {
                            display: 'none'
                        });
                    }, this)
                });
            } else {
                // desktop
                tl.to([bg, this.el], 1, {
                    y: "130%",
                    ease: Quart.easeInOut,
                    onComplete: _.bind(function () {
                        gs.TweenMax.set(bg, {
                            display: 'none'
                        });
                        gs.TweenMax.set(this.el, {
                            display: 'none'
                        });
                    }, this)
                });
            }

            return tl;
        };


    var LocationView = function () {
        AbstractView.call(this);
        this.el = document.getElementById('location');
    };

    LocationView.prototype = _.assign({

        name: 'location-view',

        _onSocialClick: function (e) {
            var target = e.currentTarget;
            if (target.id) {

                if (window.open) {
                    e.stopPropagation();
                    e.preventDefault();
                    var href = target.getAttribute("href");
                    window.open(href, 'social-share-window', 'WIDTH=600,HEIGHT=500,resizable,scrollbars=0,menubar=0,toolbar=0,location=0')

                    return;
                }

                return e;


            } else {
                return e;
            }
        },

        _onresize: function () {
            var bg = document.getElementById('bg-container');
            if (!document.body.classList.contains('mobile')) {
                TweenMax.set(bg.querySelector('.bg:last-child'), {
                    x: window.innerWidth,
                    y: '0%'
                });
                bg = document.getElementById('bg-container').querySelector('.bg:nth-child(2)');
                gs.TweenMax.set(bg, {
                    display: 'block',
                    x: 0,
                    y: '50%'
                });
            } else {
                bg = document.getElementById('bg-container').querySelector('.bg:nth-child(2)');
                gs.TweenMax.set(bg, {
                    display: 'none'
                });
            }
        },

        _onreversecomplete: function () {},

        init: function (data) {
            var el = document.querySelector('#location .location-wrapper');

            if (data) {
                data.share = model.share;
            }

            window.addEventListener('resize', this._onresize);
            //                zoomControls = document.querySelector('#ui-controls .zoom');
            el.innerHTML = tpl.render(data);
            //            this.tl = _.bind(_initTimeline, this)();
            if (!data) {
                gs.TweenMax.set(this.el, {
                    y: '100%'
                });
                // show zoom controls
            } else {
                // hide zoom controls
            }
        },

        update: function (data) {
            var el = document.querySelector('#location .location-wrapper'),
                bg = document.getElementById('bg-container').querySelector('.bg:nth-child(2)'),
                wrapper = this.el.querySelector('.location-wrapper'),
                tl = new gs.TimelineMax();

            if (data) {
                data.share = model.share;
            }
            
            gs.TweenMax.killChildTweensOf(this.el);
            gs.TweenMax.killTweensOf(this.el);

            if (document.body.classList.contains('mobile')) {
                if (data) {
                    tl.to(this.el, 0.8, {
                        y: '100%',
                        ease: Quint.easeInOut,
                        onComplete: function () {
                            el.innerHTML = tpl.render(data);
                        }
                    });
                    tl.to(this.el, 0.6, {
                        y: '0%',
                        ease: Quint.easeInOut
                    });
                } else {
                    tl.to(this.el, 0.5, {
                        y: '100%',
                        ease: Quint.easeInOut
                    });
                }
            } else {

                if (data) {

                    tl.to([bg, this.el], 0.5, {
                        y: "100%",
                        ease: Quint.easeOut,

                        onComplete: _.bind(function () {
                            el.innerHTML = tpl.render(data);
                            gs.TweenMax.set(this.el, {
                                y: '0%'
                            });
                            gs.TweenMax.to([bg], 1.2, {
                                y: "50%",
                                ease: Quint.easeInOut
                            });
                            _.each(wrapper.querySelector('.details').children, function (el, index) {
                                gs.TweenMax.from(el, 1.2, {
                                    y: 60,
                                    opacity: 0,
                                    ease: Quint.easeInOut,
                                    delay: index * -0.1
                                });
                            }, this);
                        }, this),
                    });
                }

            }

        },

        addEventListeners: function () {
            window.addEventListener('resize', this._onresize);
            _.each(this.el.querySelectorAll('a'), function (el) {
                el.addEventListener('click', this._onSocialClick);
            }, this);
        },
        removeEventListeners: function () {
            window.removeEventListener('resize', this._onresize);
            _.each(this.el.querySelectorAll('a'), function (el) {
                el.removeEventListener('click', this._onSocialClick);
            }, this);
        }
    }, AbstractView.prototype, {

        playIn: function () {
            this.addEventListeners();
            var tl = _.bind(_timelineIn, this)();
            tl.play();
            /*
            var bg = document.getElementById('bg-container').querySelector('.bg:nth-child(2)');

            gs.TweenMax.set(bg, {
                y: window.innerHeight,
                x: 0,
                backgroundColor: '#84D2DA'
            });
            gs.TweenMax.set(this.el, {
                display: 'block'
            });
            gs.TweenMax.to(bg, 1, {
                y: "50%",
                delay: 0.25,
                ease: Quart.easeInOut
            });
            */

        },
        playOut: function () {
            this.removeEventListeners();
            var tl = _.bind(_timelineOut, this)();
            tl.play();
            /*
            var bg = document.getElementById('bg-container').querySelector('.bg:nth-child(2)');

            gs.TweenMax.to(bg, 1, {
                y: "100%",
                delay: 0.25,
                ease: Quart.easeInOut,
                onComplete: _.bind(function () {
                    gs.TweenMax.set(this.el, {
                        display: 'none'
                    });
                }, this)
            });
            */

        }
    });

    module.exports = LocationView;


}());


/** WEBPACK FOOTER **
 ** ./holiday-map/location.js
 **/